import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ModalRoutes from '../../ModalRoutes';
import Navbar from '../../../Navbar';
import { Trans } from 'react-i18next';
import {Modal} from 'react-router-modal';
import { debounce } from "lodash";
import { constants } from '../../../../Helpers/Constants';
import ExpenseActionsComponent from '../../../Stakeholder/ExpenseActionsComponent.jsx';
import { checkCredentials } from '../../../../Helpers/checkCredentials';

import { LoadingIcon, LoadingIconRow } from '../../../Common/Loading_Icon';
import { SvgDollarSymbol } from '../../../Common/Buttons/Icons';
import OL_Expense from './OL_Expense';
import VehicleCell from '../Vehicle/VehicleCell';
import EmptyState from '../../../Common/EmptyState';
import { Range } from 'rc-slider';

class ExpensesOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sort_filter: null, sort_direction: null,
            current_filters: {
                'search': "", 
                'oem': [], 
                'categories': [],
                'style': {},
                'date': {min: 0, max: 90},
                'amount': {min: 0, max: 1000}
            },
            previous_filters: {
                'search': "", 
                'oem': [], 
                'categories': [],
                'style': {},
                'date': {min: 0, max: 90},
                'amount': {min: 0, max: 1000}
            },
            default_filters: {
                'search': "", 
                'oem': [], 
                'categories': [],
                'style': {},
                'date': {min: 0, max: 90},
                'amount': {min: 0, max: 1000}
            },
            available_filters: [],
            filter_dropdowns: {'categories': false, 'oem': false, 'style': false, 'date': false, 'amount': false},
            searching: false,
            loading_main: true,
            expenses: [],
            addExpense: constants.add_expense_mode.hidden,
            v_id: null,
            expense_id: null,
            mobile_filters: false,
            total_expenses: 0
        };
        this.retrieveExpenseData = this.retrieveExpenseData.bind(this);
        this.renderAttachments = this.renderAttachments.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.renderAddExpense = this.renderAddExpense.bind(this);
        this.closeAddExpense = this.closeAddExpense.bind(this);
        this.getExpenseCategories = this.getExpenseCategories.bind(this);
        this.renderAttachments = this.renderAttachments.bind(this);
        this.onClickEdit = this.onClickEdit.bind(this);
        this.onClickView = this.onClickView.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.toggleMobile = this.toggleMobile.bind(this);
        this.updateRange = this.updateRange.bind(this);
        this.updateCheckBox = this.updateCheckBox.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.changedFilters = this.changedFilters.bind(this);
        this.handleChange = debounce(this.handleChange, 500);
        this.clearSearch = this.clearSearch.bind(this);
        this.addSortClasses = this.addSortClasses.bind(this);
        this.toHashString = this.toHashString.bind(this);
        this.getSum = this.getSum.bind(this);
    }

    componentDidMount() {
        document.title = "Expenses - FleetXPress";
        this.retrieveExpenseData();
    }

    retrieveExpenseData () {
        var self = this;

        axios.get('/ajax/expenses')
        .then(function (response) {
            checkCredentials(response)
            self.setState({
                expenses: response?.data.data.data, 
                loading_main: false, 
                available_filters: response?.data.filters, 
                total_expenses: response?.data.data.data.length, 
            });
        })
        .catch(function(error) {
            if(error.response?.status == 401 || error.response?.status == 400){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateSorting(name) {
        var sort_direction = this.state.sort_direction;
        var sort_filter = this.state.sort_filter;

        if (sort_filter !== name) {
            sort_filter = name;
            sort_direction = "desc";
        } else {
            if (sort_direction === "desc") {
                sort_direction = "asc"
            } else if (sort_direction === "asc") {
                sort_direction = null
                sort_filter = null
            } else {
                sort_filter = name;
                sort_direction = "asc"
            }
        }

        this.setState({
            sort_direction: sort_direction,
            sort_filter: sort_filter
        })

        this.applyFilters(sort_filter, sort_direction)
    }

    updateRange(e, category) {
        var filters = this.state.current_filters;
        filters[category].min = e[0]
        filters[category].max = e[1]

        this.setState({
            current_filters: filters
        })
    }

    updateCheckBox(category, check) {
        var filters = this.state.current_filters;
        let index = filters[category].indexOf(check);
        
        if (index == -1) {
            filters[category].push(check);
        } else {
            filters[category].splice(index, 1);
        }
  
        this.setState({
            current_filters: filters
        })
    }

    toHashString(arr) {
        let str = "";
        arr.map((item, index) => {
            str = str.concat("#" + item);
        })
        return str;
    }

    resetFilters() {
        this.setState({
            current_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            previous_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            loading_main: true,
            mobile_filters: false
        })
        
        var self = this;

        axios.get('/ajax/expenses')
        .then(function (response) {
            checkCredentials(response)
            self.setState({expenses: response?.data.data.data, loading_main: false, available_filters: response?.data.filters, total_expenses: response?.data.data.data.length});
        })
        .catch(function(err) {
            if(error.response?.status == 401 || error.response?.status == 400){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    toggleDropdown(type) {
        var filter_dropdowns = this.state.filter_dropdowns
        filter_dropdowns[type] = !filter_dropdowns[type]
        this.setState({
            filter_dropdowns: filter_dropdowns
        })
    }

    toggleMobile(name) {
        this.setState({
            [name]: !this.state[name]
        })
    }

    /*
    * Compares previous filters with recently checked ones, returns true if the filters have been changed and can be updated
    */
    changedFilters(compare_dictionary) {
        if (JSON.stringify(compare_dictionary) !== JSON.stringify(this.state.current_filters)) {
            return true;
        }
        return false;
}

    handleChange(id) {
        var search = document.getElementById(id).value;
        var filters = this.state.current_filters;
        filters['search'] = search;

        this.setState({
            searching: true,
            filters: filters
        })

        this.applyFilters()
    }

    onClickEdit (id, v_id) {
        this.setState({addExpense: constants.add_expense_mode.edit, expense_id: id, v_id});        
    }

    onClickView (id, v_id) {
        this.setState({addExpense: constants.add_expense_mode.edit, expense_id: id, v_id})
    }

    applyFilters(sort_filter = this.state.sort_filter, sort_direction = this.state.sort_direction) {
        var self = this;

        this.setState({
            loading_main: true,
            mobile_filters: false
        })

        axios.get('/ajax/expenses', {
            params: {
              search_term: this.state.current_filters.search,
              oem: self.toHashString(this.state.current_filters.oem),
              categories: self.toHashString(this.state.current_filters.categories),
              date_min: this.state.current_filters.date.min,
              date_max: this.state.current_filters.date.max,
              amounts_min: this.state.current_filters.amount.min,
              amounts_max: this.state.current_filters.amount.max,
              sort_filter: sort_filter,
              sort_direction: sort_direction,
            }})
        .then(function(response) {
            checkCredentials(response)
            self.setState({expenses: response?.data.data.data, loading_main: false, searching: false, previous_filters: JSON.parse(JSON.stringify(self.state.current_filters))});
        })
        .catch(function(error) {
            if(error.response?.status == 401 || error.response?.status == 400){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    addSortClasses(name) {
        if (this.state.sort_filter === name) {
            if (this.state.sort_direction === "asc") {
                return " fa-sort-up primary"
            } else if (this.state.sort_direction === "desc"){
                return " fa-sort-down primary"
            }
        } else {
            return " fa-sort"
        }
    }

    clearSearch() {
        var filters = this.state.current_filters;
        filters['search'] = "";
        document.getElementById('searchbar').value = "";

        this.setState({
            filters: filters
        })

        this.applyFilters()
    }

    getSum(field) {
        let total = 0;
        this.state.expenses.map((expense) => {
            expense.line_items.map((item) => {
                total += Number.parseInt(item[field]);
            })
        })
        return total;
    }

    getExpenseCategories(expense) {
        if (expense.categories && expense.categories.length >= 1) {
            return <div>
                {expense.categories.map((category, index) => (
                    <span>{category.category.Name + (index < expense.categories.length - 1 ? ", " : "")}</span>
                ))}
            </div>
        }
        return "None";
    }

    renderAttachments (expense) {
        if (expense.attachments && expense.attachments.length >= 1) {
            return <div>
                {expense.attachments.map(attachment => (
                    attachment.Active === 1 ? 
                    <div>
                        <span onClick={()=> {window.open('' + attachment.URL)}} className="link" style={{fontSize: 14, cursor: 'pointer'}}>
                            {attachment.Name?.split('_')[3]?.length > 10 ? attachment.Name?.split('_')[3].slice(0,10) + '...' : attachment.Name?.split('_')[3]}
                        </span>
                    </div> : null
                ))}
            </div>
        }
        return "None";
    }

    closeAddExpense() {
        this.setState({
            addExpense: constants.add_expense_mode.hidden,
            v_id: null,
            expense_id: null
        })
    }

    renderFilterBar() {
        return (
                <div className = {"filterbar" + (this.state.mobile_filters ? " is-shown" : "")}> {/*add class 'is-shown' to unhide on mobile */}
                    <div className = "filtertitle-wrapper">
                        <div className = "filtertitle">
                            <h2>{this.state.expenses.length} / {this.state.total_expenses}<Trans> Expenses</Trans></h2>
                            <a className = "close-icon" onClick={() => (this.toggleMobile('mobile_filters'))}>
                                <img src = "images/png-icons/close-grey.png"/>
                            </a>
                        </div>
                    </div>
                    <div className = "filtersection">
                        <div className = "filtersection-wrapper">
                            {/* <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <p><Trans>Net Cost</Trans>: </p>
                                    <p>${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getSum('Net_Cost'))}</p>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <p><Trans>Tax</Trans>: </p>
                                    <p>${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getSum('Tax'))}</p>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontWeight: 'bold'}}>
                                    <p style={{marginBottom: 15}}><Trans>Total Cost</Trans>: </p>
                                    <p style={{marginBottom: 15}}>${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getSum('Total_Cost'))}</p>
                                </div>
                            </div> */}
                            {/*If Completed */}
                            <ul className = "completed-tab">
                                <li className={"filter-expandable" + (this.state.filter_dropdowns.date ? " is-expanded" : "")}>
                                <span className = "filter-name"><Trans>Expense Date</Trans></span>
                                    {
                                    this.state.current_filters.date.min === 0 && this.state.current_filters.date.max === 90 ?
                                        <div className={"expand-btn" + (this.state.filter_dropdowns.date ? " is-expanded": "")} onClick={() => this.toggleDropdown('date')}></div>
                                    :
                                        <div className="expand-btn is-expanded disabled"></div>
                                    }
                                    <div className = "clearfix"></div>
                                    <ul className = "filter-ul filter-slider">
                                        <li>
                                            <p>{this.state.current_filters.date.min} - {this.state.current_filters.date.max}{this.state.current_filters.date.max === 90 ? <span>+</span> : null} <Trans>days</Trans></p>
                                            <Range allowCross={false} min={0} max={90} defaultValue={[0, 90]} value={[this.state.current_filters.date.min, this.state.current_filters.date.max]} onChange={(e) => {this.updateRange(e, "date")}} />
                                            <div className = "clearfix"></div>
                                        </li>
                                    </ul>
                                </li>
                                <li className={"filter-expandable" + (this.state.filter_dropdowns.amount ? " is-expanded" : "")}>
                                <span className = "filter-name"><Trans>Total Invoice Cost</Trans></span>
                                    {
                                    this.state.current_filters.amount.min === 0 && this.state.current_filters.amount.max === 1000 ?
                                        <div className={"expand-btn" + (this.state.filter_dropdowns.amount ? " is-expanded": "")} onClick={() => this.toggleDropdown('amount')}></div>
                                    :
                                        <div className="expand-btn is-expanded disabled"></div>
                                    }
                                    <div className = "clearfix"></div>
                                    <ul className = "filter-ul filter-slider">
                                        <li>
                                            <p>${this.state.current_filters.amount.min} - ${this.state.current_filters.amount.max}{this.state.current_filters.amount.max === 1000 ? <span>+</span> : null}</p>
                                            <Range allowCross={false} min={0} max={1000} defaultValue={[0, 1000]} value={[this.state.current_filters.amount.min, this.state.current_filters.amount.max]} onChange={(e) => {this.updateRange(e, "amount")}} />
                                            <div className = "clearfix"></div>
                                        </li>
                                    </ul>
                                </li>
                                <li className={"filter-expandable" + (this.state.filter_dropdowns.oem ? " is-expanded" : "")}>
                                    <span className = "filter-name"><Trans>Vehicle</Trans></span>
                                    {
                                        this.state.current_filters.oem !== {} ?
                                            <div className={"expand-btn" + (this.state.filter_dropdowns.oem ? " is-expanded": "")} onClick={() => this.toggleDropdown('oem')}></div>
                                        :
                                            <div className="expand-btn is-expanded disabled"></div>
                                    }
                                    <div className = "clearfix"></div>
                                    <ul className = "filter-ul">
                                            {this.state.available_filters?.oem?.map((oem) => {
                                                return (
                                                    <li style = {{width: 'auto'}}>  
                                                        <div style={{display: 'flex', flex: 1}}>
                                                            <label className = "has-icon float-left endline">
                                                                <input type = "checkbox" checked={this.state.current_filters.oem.includes(oem.OEM_ID)} onClick={() => this.updateCheckBox('oem', oem.OEM_ID)}/>
                                                                <span className = "checkmark"></span>
                                                                {oem.Company}
                                                            </label>
                                                        </div>   
                                                    </li>
                                                )
                                            }
                                            )}
                                            {/* <Range allowCross={false} min={0} max={90} defaultValue={[0, 90]} value={[this.state.current_filters.published.min, this.state.current_filters.published.max]} onChange={(e) => {this.updateRange(e, "published")}} /> */}
                                            <div className = "clearfix"></div>
                                    </ul>
                                </li>
                                <li className={"filter-expandable" + (this.state.filter_dropdowns.categories ? " is-expanded" : "")}>
                                    <span className = "filter-name"><Trans>Categories</Trans></span>
                                    {
                                        this.state.current_filters.categories !== {} ?
                                            <div className={"expand-btn" + (this.state.filter_dropdowns.categories ? " is-expanded": "")} onClick={() => this.toggleDropdown('categories')}></div>
                                        :
                                            <div className="expand-btn is-expanded disabled"></div>
                                    }
                                    <div className = "clearfix"></div>
                                    <ul className = "filter-ul">
                                        <li>
                                            {this.state.available_filters?.categories?.map((category) => (
                                                category.Name == null ? null : 
                                                <li style = {{width: 'auto'}}>  
                                                    <div style={{display: 'flex', flex: 1}}>
                                                        <label className = "has-icon float-left endline">
                                                            <input type = "checkbox" checked={this.state.current_filters.categories.includes(category.ID)} onClick={() => this.updateCheckBox('categories', category.ID)}/>
                                                            <span className = "checkmark"></span>
                                                            {category.Name}
                                                        </label>
                                                    </div>   
                                                </li>
                                            ))}
                                            {/* <Range allowCross={false} min={0} max={90} defaultValue={[0, 90]} value={[this.state.current_filters.published.min, this.state.current_filters.published.max]} onChange={(e) => {this.updateRange(e, "published")}} /> */}
                                            <div className = "clearfix"></div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className = "action-bottom">
                        <div className = "right">
                            <a className = {"button secondary mr-8 px-32 no-margin" + (this.changedFilters(this.state.default_filters) ? "" : " disabled")} onClick={() => this.resetFilters()}><Trans>Reset</Trans></a>
                            <a className = {"button primary px-32 no-margin" + (this.changedFilters(this.state.previous_filters) ? "" : " disabled")} onClick={() => this.applyFilters()}><Trans>Apply Filters</Trans></a>
                        </div>
                    </div>
                </div>
        )
    }

    renderAddExpense () {
        if (this.state.addExpense !== 0) {
            return (
                <Modal inClassName="overview_view w-50">
                    <OL_Expense mode={this.state.addExpense} closeOverlay={()=> {this.closeAddExpense()}}  refresh={this.retrieveExpenseData} vehicle_details={null} v_id={this.state.v_id} expense_id={this.state.expense_id} editCallback={()=>this.setState({addExpense: constants.add_expense_mode.edit})}/>
                </Modal> 
            )
        } else {
            return null;
        }
    }

    renderTable() {
        var data = this.state.expenses;

        if (data.length === 0) {
            return(
                <tbody>
                    <tr>
                        <td colSpan = '9'><EmptyState image="dollar-symbol.svg" text="No Expenses" /></td>
                    </tr>
                </tbody>
            )
        } else {
            return(
                <tbody>
                    {
                        data.map((expense) => {
                            return (expense.line_items.map((item, index) => {
                                return(
                                    <tr key={item.ID} style={{cursor: 'initial'}} onClick={()=>{this.onClickView(expense.ID, expense.V_ID)}}>
                                        <td label="Vehicle" className="align-left" style={{display: 'flex', flex: 1}} onClick={e => e.stopPropagation()}>
                                            <div className="vehicle_cell_container_container">
                                                <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={expense.vehicle} showImage showType noTooltip/>
                                            </div>
                                        </td>
                                        <td label="Date" className="align-center">
                                            <Trans>{moment(expense.Date).format('MMM DD, YYYY')}</Trans>
                                        </td>
                                        <td label="Merchant" className="align-left">
                                            {expense.Merchant}
                                        </td>   
                                        <td label="Item" className="align-center">
                                            {index + 1} / {expense.line_items_count}
                                        </td>
                                        <td label="Category" className="align-left">
                                            {item.category.Name}
                                        </td >
                                        <td label="Description" className="align-left" style={{maxWidth: '400px', width: '250px', minWidth: '100px', overflowX: 'auto'}}>
                                             {item.Description}
                                        </td>
                                        <td label="Net Cost" className="align-right">
                                            ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Net_Cost)}
                                        </td>
                                        <td label="Tax" className="align-right">
                                            ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Tax)}
                                        </td>
                                        <td label="Total Cost" className="align-right">
                                            ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Total_Cost)}
                                        </td>
                                    </tr>
                                )
                            }))
                        })
                    }
                </tbody>
            )
        }
    }

    render() {
        return (
            <div>
                <div className = "bkg-white-dark listviewnew medialist">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "titlebar">
                        <div className = "titlebar-left">
                            <div className = "left">
                                <h1>Expenses</h1>
                            </div>
                        </div>
                        <div className = "titlebar-right">
                            <div className = "right">
                                    <div className="button primary px-32" onClick={() => this.setState({addExpense: constants.add_expense_mode.add})} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingRight: 15}}>
                                        {/* <div style={{flex: 1, display: 'flex'}}>
                                            <SvgDollarSymbol fill="#fff" style={{height: 18, width: 18}}/>
                                        </div> */}
                                        <Trans>Add Expense</Trans>
                                    </div>
                                {/* <div className = "mobile-action">
                                    <a className = {"button primary circle px-32" + (this.props.stakeholder.outstanding_media_list.length > 0 ? "" : " disabled")} onClick={this.toggleMedia}><span className = "mr-8" style={{verticalAlign: "text-top"}}>{MediaAddWhite()}</span></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className = "list-container">
                        <div className = "list-wrapper">
                            {this.renderFilterBar()}
                            <div className = "mainsection">
                                <div className = "searchbar-section">
                                    <div className = "left">
                                        <div className = "searchbar-wrapper">
                                        <a className = "float-left button border white px-32 icon-btn filterbar-btn-mobile" onClick={() => {this.toggleMobile('mobile_filters')}}><img src = "images/png-icons/filter-grey.png"/> </a> 
                                            <div className = "search-field-container">
                                                <input className="search-input-field no-margin" type="text" placeholder = "Search Expenses" id="searchbar" onChange={(e) => {this.handleChange('searchbar')}} />
                                                    {/*Show when searching*/}
                                                    {
                                                        this.state.searching ?
                                                            <div className="loading-wrapper">
                                                                <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {/*Show when input field has text*/}
                                                    {
                                                        this.state.current_filters.search.length && !this.state.searching > 0 ?
                                                            <a className = "close-icon" onClick={this.clearSearch}>
                                                                <img src = "images/png-icons/close-grey.png"/>
                                                            </a> 
                                                        :
                                                            null
                                                    }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className = "table-section">
                                    {
                                        this.state.loading_main ?
                                            <LoadingIcon />
                                        :
                                        <table>
                                            <thead>
                                                <tr className = "table-header">
                                                    <th style={{maxWidth: '360px', width: '360px'}}><Trans>VEHICLE</Trans></th>
                                                    <th className={this.state.sort_filter === 'date' ? "align-center is-sorted" : "align-center"} onClick={() => {this.updateSorting("date")}}><Trans>DATE OF EXPENSE</Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("date"))}></i></th>
                                                    <th className={this.state.sort_filter === 'merchant' ? "align-left is-sorted" : "align-left"} onClick={() => {this.updateSorting("merchant")}}><Trans>MERCHANT</Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("merchant"))}></i></th>
                                                    <th className="align-center" ><Trans>ITEM #</Trans></th>
                                                    <th className="align-left" ><Trans>CATEGORY</Trans></th>
                                                    <th className="align-left" ><Trans>DESCRIPTION</Trans></th>
                                                    <th className={this.state.sort_filter === 'net_cost' ? "align-right is-sorted" : "align-right"} onClick={() => {this.updateSorting("net_cost")}}><Trans>NET COST</Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("net_cost"))}></i></th>
                                                    <th className={this.state.sort_filter === 'tax' ? "align-right is-sorted" : "align-right"} onClick={() => {this.updateSorting("tax")}}><Trans>TAX</Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("tax"))}></i></th>
                                                    <th className={this.state.sort_filter === 'total_cost' ? "align-right is-sorted" : "align-right"} onClick={() => {this.updateSorting("total_cost")}}><Trans>TOTAL COST</Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("total_cost"))}></i></th>
                                                    {/* <th className="align-right"><Trans>ACTIONS</Trans></th> */}
                                                </tr>
                                            </thead>
                                            {this.renderTable()}
                                        </table>
                                    }
                                </div>{/*End Table Section*/}
                            </div>
                        </div> {/*End New List View*/}
                    </div>
                </div>
                {this.renderAddExpense()}
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ExpensesOverview)